import React, { useState } from 'react';

const PASSWORD = 'Kittu@1';

function PasswordGate({ children }) {
  const [unlocked, setUnlocked] = useState(
    () => localStorage.getItem('apkd_auth') === '1'
  );
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    if (input === PASSWORD) {
      localStorage.setItem('apkd_auth', '1');
      setUnlocked(true);
    } else {
      setError(true);
      setInput('');
    }
  }

  if (unlocked) return children;

  return (
    <div className="gate-wrap">
      <div className="gate-bg" />
      <div className="gate-grid" />
      <div className="gate-card">
        <div className="header-eyebrow">Private Access</div>
        <h1 className="gate-title">APKD <em>Learning Program</em></h1>
        <p className="gate-sub">Enter the password to continue.</p>
        <form onSubmit={handleSubmit} className="gate-form">
          <input
            type="password"
            value={input}
            onChange={e => { setInput(e.target.value); setError(false); }}
            placeholder="Password"
            className={`gate-input${error ? ' gate-input--error' : ''}`}
            autoFocus
          />
          {error && <p className="gate-error">Incorrect password — try again.</p>}
          <button type="submit" className="gate-btn">Enter</button>
        </form>
      </div>
    </div>
  );
}

export default PasswordGate;
